module.exports = __webpack_public_path__ + "static/scopriabitareco_valori_5_energia-a4f97a1524131fe99279ffefc9acaf2c.jpg";